// Helper to retrieve the active marketplace site name / brand from PRIMARY_HOST or window.location
export function getSiteBrandName() {
  if (typeof window !== 'undefined') {
    // 1. SSR injected global variable from server environment (PRIMARY_HOST)
    if (window.__PRIMARY_HOST__ && window.__PRIMARY_HOST__.trim()) {
      return window.__PRIMARY_HOST__.replace(/^https?:\/\//i, '').replace(/^www\./i, '').split('/')[0].split(':')[0].trim();
    }
  }

  // 2. React build-time environment variable if configured
  if (process.env.REACT_APP_PRIMARY_HOST && process.env.REACT_APP_PRIMARY_HOST.trim()) {
    return process.env.REACT_APP_PRIMARY_HOST.replace(/^https?:\/\//i, '').replace(/^www\./i, '').split('/')[0].split(':')[0].trim();
  }

  // 3. Active browser domain hostname (when hosted on a real domain)
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname.replace(/^www\./, '').split(':')[0].trim();
    if (host && host !== 'localhost' && host !== '127.0.0.1') {
      return host;
    }
  }

  return 'Buy.tg'
}

// Helper to split brand name into brand text and badge text for logo display
// e.g. "buy.tg" -> { text: "Buy", badge: "TG" }
// e.g. "somedomain.tg" -> { text: "Somedomain", badge: "TG" }
// e.g. "mybrand.com" -> { text: "Mybrand.com", badge: "TG" }
// e.g. "buy" -> { text: "Buy", badge: "TG" }
export function getLogoBrandParts() {
  const fullBrand = getSiteBrandName();
  
  // If the brand ends with .tg (like buy.tg or anyname.tg)
  if (/\.tg$/i.test(fullBrand)) {
    const mainPart = fullBrand.replace(/\.tg$/i, '').trim();
    // Capitalize first letter if it's all lower/upper for aesthetic beauty, or keep case
    const formattedMain = mainPart ? (mainPart.charAt(0).toUpperCase() + mainPart.slice(1)) : 'Buy';
    return {
      text: formattedMain,
      badge: 'TG'
    };
  }

  // If brand is just "buy" (case-insensitive)
  if (/^buy$/i.test(fullBrand)) {
    return {
      text: 'Buy',
      badge: 'TG'
    };
  }

  return {
    text: fullBrand,
    badge: 'TG'
  };
}

// Helper to dynamically update the document <title> tag on page / card navigation
export function setPageTitle(pageTitle) {
  if (typeof document === 'undefined') return;
  const brand = getSiteBrandName();
  if (!pageTitle) {
    document.title = `${brand} - Premium Domain Marketplace`;
  } else if (pageTitle.includes(brand)) {
    document.title = pageTitle;
  } else {
    document.title = `${pageTitle} | ${brand}`;
  }
}
